import { gql } from "@apollo/client";

export const GET_FILE_QUERY = gql`
    query GetFile($id: ID!) {
        file(id: $id) {
            id
            file_name
            file_url
            mime_type
            file_size
            folder_id
            created_at
            created_by
            upload_status
        }
    }
`;

// Get Files by BelongsTo Query

// Product Maintenance Schedule Query (by ID)

// Product Maintenance Schedules Query

export const GET_DOCUMENT_INFORMATION_QUERY = gql`
  query GetDocumentInformation($input: GetDocumentInformationInput!) {
    getDocumentInformation(input: $input) {
      faq
      success
      message
    }
  }
`;

export const GET_CHATBOT_PREDICTION_QUERY = gql`
  query GetChatBotPrediction($input: GetChatBotPredictionInput!) {
    getChatBotPrediction(input: $input) {
      data
      success
      message
    }
  }
`;
